/********** DATATABLE **********/

export const GET_ORDERS_INVOICES_DT = 'GET_ORDERS_INVOICES_DT';
export const GET_ORDERS_INVOICES_DT_OK = 'GET_ORDERS_INVOICES_DT_OK';
export const GET_ORDERS_INVOICES_DT_ERR = 'GET_ORDERS_INVOICES_DT_ERR';
export const DO_ORDERS_INVOICES_DT_CLEANUP = 'DO_ORDERS_INVOICES_DT_CLEANUP';

/********** DATATABLE FILTERS **********/

export const APPLY_ORDERS_INVOICES_DT_FILTERS = 'APPLY_ORDERS_INVOICES_DT_FILTERS';
export const PATCH_ORDERS_INVOICES_DT_FILTERS = "PATCH_ORDERS_INVOICES_DT_FILTERS";
export const CLEAR_ORDERS_INVOICES_DT_FILTERS = "CLEAR_ORDERS_INVOICES_DT_FILTERS";
export const UNSET_ORDERS_INVOICES_DT_FILTERS = "UNSET_ORDERS_INVOICES_DT_FILTERS";